import enqueueIn from "nx-components/utils/enqueueIn";
import Url from "nexia_mobile/url";

export default {
  openFeed() {
    const path = this.getMediaType() === "image/jpeg" ? "jpeg_url" : "hd_url";

    let feedUrl = Url.withAdditionalPath(this.url(), path);
    let method = "GET";
    if (this._videoUrlLink) {
      feedUrl = this._videoUrlLink.href;
      method = this._videoUrlLink.method || "POST";
    }
    this._openFeed(feedUrl, method);
  },

  parseLinksVideoURL(links) {
    this._videoUrlLink = links[0];
  },

  closeFeed() {
    if (this._videoFeedUrl == null) {
      return;
    }

    let url;
    let method;
    if (this._stopUrl) {
      url = this._stopUrl;
      method = "POST";
    } else {
      url = this._videoFeedUrl.replace(/jpeg/, "Stop");
      method = "GET";
    }

    $.ajax({
      url,
      type: method,
    }).then(
      () => {
        this.trigger("feed:close");
      },
      (xhr) => {
        if (xhr && xhr.statusText === "abort") {
          return;
        }
        this.trigger(
          "feed:close:error",
          "There was an error closing the video feed."
        );
      }
    );

    this._videoFeedUrl = null;
  },

  startRecording() {
    if (this._videoFeedUrl == null) {
      return;
    }

    if (this.isHD()) {
      $.ajax({
        url:
          this._recordUrl ||
          Url.withAdditionalPath(this.url(), "start_recording"),
        type: "POST",
      }).then(
        () => {
          this.trigger("feed:record");
        },
        (xhr) => {
          if (xhr && xhr.statusText === "abort") {
            return;
          }
          this.trigger(
            "feed:record:error",
            "An error occurred starting the recording."
          );
        }
      );
    } else {
      this.trigger("feed:record");
    }
  },

  isHD() {
    return this.get("quality") === "hd";
  },

  getMediaType(isLive) {
    const mediaTypeFromAttributes = this.get("mediaType");
    if (mediaTypeFromAttributes) {
      return mediaTypeFromAttributes;
    } else if (this.isHD()) {
      return isLive ? "application/x-mpegURL" : "video/mp4";
    } else {
      return "image/jpeg";
    }
  },

  enableWaitingForValidFeed(yesno) {
    this._waitForValidFeed = yesno;
  },

  canPanTilt() {
    return false;
  },

  _openFeed(url, method) {
    $.ajax({
      url,
      type: method,
    }).then(
      (data) => {
        this._processFeedResult(data);
      },
      (xhr) => {
        if (xhr && xhr.statusText === "abort") {
          return;
        }
        this.trigger(
          "feed:error",
          "There was an error opening the video feed."
        );
      }
    );
  },

  _processFeedResult(passedData) {
    let data = passedData;
    if (data.result != null) {
      data = data.result;
    }
    this._videoFeedUrl = data.url;
    this._recordUrl = data.record_url;
    this._stopUrl = data.stop_url;

    if (this._waitForValidFeed) {
      this._pollUntilValid(this._videoFeedUrl);
    } else {
      this._triggerFeedOpenEvent(this._videoFeedUrl);
    }
  },

  _pollUntilValid(url, attempts = 0) {
    if (attempts >= 20) {
      this.trigger("feed:error", "There was an error opening the video feed.");
      return;
    }

    $.ajax({
      url,
      type: "GET",
    })
      .done(() => {
        this._triggerFeedOpenEvent(url);
      })
      .fail((xhr) => {
        if (xhr && xhr.statusText === "abort") {
          return;
        }
        enqueueIn(() => this._pollUntilValid(url, attempts + 1), 500);
      });
  },

  _triggerFeedOpenEvent(url) {
    this.trigger("feed:open", url);
  },
};



// WEBPACK FOOTER //
// ./src/models/mixins/video_feed.js